<template>
  <div class="p-6 bg-indigo-800 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-2xl">
      <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('dashboard')">
          SAPBKPP
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        <span class="text-white font-medium">Lupa Password</span>
      </h1>

      <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
        <div class="p-4 flex flex-wrap">
          <p class="py-2">
            Apakah anda pernah terdaftar disitus SAPBKPP namun tidak ingat passwordnya?
          </p>
          <p class="py-2">
            Untuk mengatur ulang password silahkan tuliskan alamat email yang terdaftar pada situs ini dan klik pada tombol <b>Kirim Reset Link</b>
          </p>
          <p class="py-2">
            Selanjutnya silahkan cek email anda untuk mendapatkan link menuju ke halaman pengaturan password.
          </p>
        </div>

        <form @submit.prevent="submit">
          <div class="px-4 flex flex-wrap">
            <text-input
              v-model="form.email"
              :error="form.errors.email"
              class="pr-6 pb-8 w-full lg:w-1/2"
              label="Alamat email yang sudah pernah terdaftar" />
          </div>
          <div v-if="status" class="px-4 mb-4 font-medium text-sm text-green-600">
            {{ status }}
          </div>
          <div class="px-4 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap justify-end items-center">
            <div>
              <loading-button
                :loading="form.processing"
                class="btn-indigo"
                type="submit">
                Kirim Reset Link
              </loading-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Forgot Password' },
  components: {
    LoadingButton,
    TextInput,
  },
  remember: 'form',
  props: {
    status: String,
  },
  data () {
    return {
      form: this.$inertia.form({
        email: null,
      }),
    }
  },
  methods: {
    submit () {
      this.form.post(this.route('password.email'))
    },
  },
}
</script>
